<template>
  <!-- <div class="bg_gradient"> -->
  <div>
    <nav class="navbar navbar-light bg-graynav">
      <a class="navbar-brand" href="\">
        <img src="img/brand/Arcadis360HubNav.png">
      </a>
      <div v-if="accessToken">
        <form class="navbar-search navbar-search-light form-inline mr-3 d-none d-md-flex ml-lg-auto">
          <ul class="navbar-nav align-right">
            <li class="nav-item">
              <router-link
                to="/"
                class="nav-link"
                href="/"
              >
                  <img src="img/icons/projectIcon/contact_icon.png" title="Contact Us">
              </router-link>
            </li>
          </ul>
          <ul class="navbar-nav align-right">
            <li class="nav-item">
              <router-link
                to="/"
                class="nav-link"
                href="/"
              >
                  <img src="img/icons/projectIcon/logout_icon.png" v-on:click="logout" title="Logout">
              </router-link>
            </li>
          </ul>


        </form>
        <!-- <button type="button" name="button" v-on:click="logout">logout</button> -->
      </div>
      <!-- <form class="navbar-search navbar-search-light form-inline mr-3 d-none d-md-flex ml-lg-auto">
          <div class="form-group mb-0">
              <base-input placeholder="LOGIN:"
                          class="input-group-alternative"
                          alternative=""
                          addon-right-icon=""
                          disabled>
              </base-input>
          </div>
      </form> -->
    </nav>
    <!-- <div class="spacetop"></div> -->
    <!-- <LandingPage></LandingPage> -->
    <!-- <LandingPageNew></LandingPageNew> -->
    <div v-if="accessToken">
      <LandingPage/>
    </div>
    <div v-else>
      <br><br><br>
      <Login/>
    </div>
  </div>

</template>

<script>
// import LandingPage from '../views/LandingPage.vue';
// import LandingPageNew from '../views/LandingPageNew.vue';
import Login from '../views/Login.vue'
import LandingPage from '../views/LandingPage.vue'
import DashboardLayout from '../layout/DashboardLayout.vue'
export default {
  name: 'LandingPageLayout',
  components: {
    // LandingPage
    // LandingPageNew
    Login,
    LandingPage,
    DashboardLayout
  },
  data() {
    return {
      accessToken: ""
    }
  },
  computed: {
    accessTokenTemp () {
      return this.$store.state.userModule.accessToken
    }
  },
  created() {
    if (sessionStorage.hasOwnProperty("accessToken")) {
      this.accessToken = sessionStorage.getItem("accessToken")
      this.$store.commit("userModule/storeToken", this.accessToken)
    }
  },
  watch: {
    accessTokenTemp(newVal, oldVal) {
      this.accessToken = newVal;
      console.log("entered WATCH on Landing");
    }
  },
  methods: {
    logout: function() {
      sessionStorage.setItem("accessToken","")
      this.$store.commit("userModule/storeToken", "")
    }
  }
}
</script>

<style>
/* c55a11
  029bd4
*/

.spacetop{
    width: 100%;
    height: 90px;
    /* background: red; */
}



</style>
